import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import SocialSummary from './social-summary';
import LegacyLinksForm from './legacy-links-form'
import { toast } from '../../components/snackbar';
import FacebookPagesSection from './facebook-pages-section';
import { useNextAuth } from '../../auth/hooks/use-next-auth';
import FacebookAccountSection from './facebook-account-section';
import InstagramAccountsSection from './instagram-accounts-section';
import axios from 'axios';
import { endpoints } from '@/utils/axios';

export function AccountSocialLinks() {
  const { session } = useNextAuth();
  const [socialAccounts, setSocialAccounts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [instagramPageData, setInstagramPageData] = useState()
  const [facebookPageData, setFacebookPageData] = useState()

  console.log("instagramPageData : ", instagramPageData);
  console.log("session : ", session);
  // console.log(socialAccounts);

  useEffect(() => {
    fetchAccounts()
    fetchPages()
  }, [])

  // {
  //   "pages": [
  //     {
  //       "pageId": "790151054174393",
  //       "name": "Instagram page"
  //     }
  //   ]
  // }

  const fetchAccounts = async () => {
    const Response = await axios.get(endpoints.instagram.accounts, {
      headers: { Authorization: `Bearer ${sessionStorage.jwt_access_token}` }
    })

    setInstagramPageData(Response.data.data)

    const Res2 = Response.data.data.accounts && Response.data.data.accounts[0] && await axios.get(endpoints.instagram.conversations + "?igUserId=" + Response.data.data.accounts[0].igUserId, {
      headers: { Authorization: `Bearer ${sessionStorage.jwt_access_token}` }
    })

    console.log("conversations: ", Res2);
  }

  const fetchPages = async () => {
    const Response = await axios.get(endpoints.meta.pagesFacebook, {
      headers: { Authorization: `Bearer ${sessionStorage.jwt_access_token}` }
    })

    setFacebookPageData(Response.data.data)

    console.log(Response.data.data);
  }

  const methods = useForm({
    defaultValues: {
      facebook: '',
      instagram: '',
      linkedin: '',
      twitter: '',
    },
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    const fetchSocialAccounts = async () => {
      if (!session) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch('/api/user/social-accounts');
        if (response.ok) {
          const result = await response.json();
          console.log(result);

          // setSocialAccounts(result.data);
        }
      } catch (error) {
        console.error('Error fetching social accounts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSocialAccounts();
  }, [session]);

  const onSubmit = handleSubmit(async (data) => {
    try {
      setSubmitting(true);
      console.info('DATA', data);
      await new Promise((resolve) => setTimeout(resolve, 500));
      reset();
      toast.success('Update success!');
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  });

  if (loading) {
    return (
      <Card sx={{ p: 3 }}>
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}
        >
          <CircularProgress />
        </Box>
      </Card>
    );
  }

  return (
    <Card sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Social Links
      </Typography>

      {/* Facebook Section */}
      <FacebookPagesSection socialAccounts={facebookPageData} />

      <Divider sx={{ my: 3 }} />

      {/* Facebook Login Section */}
      <FacebookAccountSection session={session} />

      <Divider sx={{ my: 3 }} />

      {/* Instagram Section */}
      <InstagramAccountsSection socialAccounts={instagramPageData} session={session} />

      {/* Summary */}
      {socialAccounts?.summary && <SocialSummary summary={socialAccounts.summary} />}

      <Divider sx={{ my: 3 }} />

      {/* Legacy Social Links Form */}
      <LegacyLinksForm
        methods={methods}
        onSubmit={onSubmit}
        submitting={submitting}
        isSubmitting={isSubmitting}
      />
    </Card>
  );
}
